import axios from "axios";
import { apiError } from "@/lib/api";

// Client HTTP séparé pour l'Espace patient : jeton en localStorage (clé distincte), refresh cookie dédié /api/patient/auth.
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const papi = axios.create({ baseURL: BASE, withCredentials: true });
const KEY = "sanitdocs.patient.token";
export const ORG_KEY = "sanitdocs.patient.org";
export const getTok = () => localStorage.getItem(KEY);
export const setTok = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));
papi.interceptors.request.use((c) => { const t = getTok(); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });
papi.interceptors.response.use((r) => r, async (err) => {
  const o = err.config;
  if (err.response?.status === 401 && !o._retry && !o.url.includes("/patient/auth/")) {
    o._retry = true;
    try { const { data } = await axios.post(`${BASE}/patient/auth/refresh`, {}, { withCredentials: true }); setTok(data.access_token); o.headers.Authorization = `Bearer ${data.access_token}`; return papi(o); }
    catch { setTok(null); }
  }
  return Promise.reject(err);
});
export const perr = (e) => apiError(e.response?.data?.detail) || e.message;
